import type z from "zod";
import { BaseV1Schema } from "./base/V1.schema";
import { FreeV1Schema } from "./free/V1.schema";
import { FreeV2Schema } from "./free/V2.schema";
import { ProV1Schema } from "./pro/V1.schema";
import { BaseV2Schema } from "./base/V2.schema";
import { ProV2Schema } from "./pro/V2.schema";

export const Schemas = {
  "free@1": FreeV1Schema,
  "free@2": FreeV2Schema,
  "pro@1": ProV1Schema,
  "pro@2": ProV2Schema,
  "base@1": BaseV1Schema,
  "base@2": BaseV2Schema,
} as const;

export type VersionId = keyof typeof Schemas;
export type Plan = VersionId extends `${infer P}@${string}` ? P : never;
export const LatestVersions: Record<Plan, VersionId> = {
  free: "free@2",
  base: "base@2",
  pro: "pro@2",
};

export type LatestConfigMap = {
  free: z.infer<typeof FreeV2Schema>,
  base: z.infer<typeof BaseV2Schema>,
  pro: z.infer<typeof ProV2Schema>,
};

export type LatestConfig = LatestConfigMap[keyof LatestConfigMap];